import { IconButton, Modal } from "src/Components";
import { CallByNumber, LoginModal, PostponeModal, RedirectModal, ChoicePauseReasonsModal } from "./Modals";
import { EQModalStates, EQModals } from "./";
import { EQueueType } from "src/Types/ReDoc/EQueue";
import CompleteModal from "./Modals/CompleteModal/CompleteModal";

interface EQueueModalsProps {
	modalState: EQModalStates;
	type: EQueueType;
	onAction: (action: string, payload?: unknown) => void;
	onClose: () => void;
	onLogin: (isSuccess: boolean) => void;
	setShowWidget: (v: boolean) => void;
	showError: (message: string, title?: string) => void;
	setPostCompleteAction: (v: string | null) => void;
}

export const EQueueModals: React.FC<EQueueModalsProps> = ({
	modalState, type, onAction, onClose, onLogin, setShowWidget, showError, setPostCompleteAction
}) => {
	const renderModalToolbar = (onModalClose: () => void) => {
		const mState = EQModals[modalState];
		const onNextState = () => {
			onClose();
			if (!!mState.onNextState.onAction) onAction(mState.onNextState.onAction);
		};
		return (
			<>
				{ !!mState.onCloseTitle && <IconButton outline onClick={onModalClose}>{mState.onCloseTitle}</IconButton> }
				{ !!mState.onNextState && <IconButton color={mState.color} onClick={onNextState}>{mState.onNextState.title}</IconButton> }
			</>
		);
	};

	const renderAskModal = () => {
		const mState = EQModals[modalState];
		const onModalClose = () => { onClose(); setShowWidget(true); };
		return (
			<Modal
				isOpen={modalState !== EQModalStates.None}
				title={mState.title}
				onClose={onModalClose}
				color={mState.color}
				renderIcon={ !!mState.icon ? <mState.icon /> : null }
				renderFooter={renderModalToolbar(onModalClose)}
			>
				{mState.text}
			</Modal>
		);
	};

	const renderModal = (): React.ReactElement | null => {
		switch (modalState) {
			case EQModalStates.QueueIsEmpty:
			case EQModalStates.AskCancelCall:
			case EQModalStates.Exit:
			case EQModalStates.AskExitCap:
				return renderAskModal();
			case EQModalStates.AskComplete:
				return (
					<CompleteModal
						type={type}
						isOpen={modalState === EQModalStates.AskComplete}
						onClose={() => { setPostCompleteAction(null); onClose(); }}
						onAction={onAction}
					/>
				);
			case EQModalStates.AskCap:
				return <ChoicePauseReasonsModal type={type} isOpen={modalState === EQModalStates.AskCap} onClose={onClose} onAction={onAction} />;
			case EQModalStates.AscCallByNumber:
				return <CallByNumber type={type} isOpen={modalState === EQModalStates.AscCallByNumber} onClose={onClose} onAction={onAction} />;
			case EQModalStates.AskPostPone:
				return <PostponeModal type={type} isOpen={modalState === EQModalStates.AskPostPone} onClose={onClose} onAction={onAction} />;
			case EQModalStates.AskRedirect:
				return <RedirectModal type={type} isOpen={modalState === EQModalStates.AskRedirect} onClose={onClose} onAction={onAction} />;
			case EQModalStates.Login:
				return <LoginModal type={type} setError={showError} onLogin={onLogin} onClose={onClose} />;
			case EQModalStates.None:
			default:
				return null;
		}
	};

	return renderModal();
};
